import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { PostCard } from "../components/PostCard";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Loader2 } from "lucide-react";

export default function PostPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    api.get(`/posts/single/${id}`).then(({ data }) => setPost(data)).catch(() => setMissing(true));
  }, [id]);

  return (
    <div className="max-w-2xl mx-auto">
      <Button variant="ghost" onClick={() => navigate("/feed")} className="mb-4" data-testid="back-to-feed"><ArrowLeft className="w-4 h-4 mr-2" />Back to feed</Button>
      {missing ? <div className="text-center text-spotter-maroon py-10">This post is no longer available.</div>
        : !post ? <div className="flex justify-center py-10"><Loader2 className="w-8 h-8 animate-spin text-spotter-maroon" /></div>
        : <PostCard post={post} onDeleted={() => navigate("/feed")} />}
    </div>
  );
}
